var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "81.5 121.17 238.25 223.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.747 271.525C279.954 312.394 228.421 347.171 178.319 343.993C128.092 340.675 79.1719 299.262 81.5867 258.418C84.1263 217.713 138.166 177.43 186.481 157.337C234.632 137.392 277.058 137.637 300.347 161.023C323.512 184.269 327.499 230.943 303.747 271.525Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.49 187.747L245.999 187.747L245.999 165.555C245.999 141.077 226.298 121.171 202.072 121.171C177.847 121.171 158.146 141.077 158.146 165.555L158.146 187.747L152.655 187.747C143.577 187.747 136.183 195.211 136.183 204.391L136.183 282.063C136.183 291.243 143.577 298.707 152.655 298.707L251.49 298.707C260.568 298.707 267.962 291.243 267.962 282.063L267.962 204.391C267.962 195.211 260.568 187.747 251.49 187.747ZM172.788 165.555C172.788 149.236 185.922 135.966 202.072 135.966C218.223 135.966 231.357 149.236 231.357 165.555L231.357 187.747L172.788 187.747L172.788 165.555ZM209.393 244.869L209.393 261.721C209.393 265.804 206.121 269.118 202.072 269.118C198.024 269.118 194.751 265.804 194.751 261.721L194.751 244.869C190.395 242.302 187.43 237.583 187.43 232.131C187.43 223.972 193.997 217.336 202.072 217.336C210.148 217.336 216.715 223.972 216.715 232.131C216.715 237.583 213.75 242.302 209.393 244.869Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLock);
export default __webpack_public_path__ + "static/media/image-lock.250fc36c2f060b401f833ae910d87f3d.svg";
export { ForwardRef as ReactComponent };